import { LinkProps } from '@tanstack/react-router';
import { Fragment } from 'react';
import styled from 'styled-components';

import { IconChevronRight } from '../../common/icons/cdl/ChevronRight';
import { theme } from '../../common/ui/theme';
import { Link } from '../Link/Link';
import { Text } from '../Text/Text';

export interface BreadcrumbLink {
    label: string;
    linkOptions: LinkProps;
}

const BreadcrumbsContainer = styled.nav`
    display: flex;
    align-items: center;
    gap: ${theme.space[4]};
    font-size: ${theme.fontSizes[12]};
    line-height: ${theme.lineHeights[18]};
`;

const BreadcrumbSeparator = styled.span`
    color: ${theme.colors.foreground.muted};
    display: flex;
    align-items: center;
`;

interface BreadcrumbsProps {
    links: BreadcrumbLink[];
    currentPage?: string;
}

export const Breadcrumbs = ({ links, currentPage }: BreadcrumbsProps) => {
    if (!links || links.length < 1 || links.length > 10) {
        if (process.env.NODE_ENV === 'development') {
            throw new Error(`Breadcrumbs: Expected 1-10 links, received ${links?.length || 0}`);
        }
        return null;
    }

    return (
        <BreadcrumbsContainer>
            {links.map((link, index) => {
                return (
                    <Fragment key={index}>
                        {index > 1 ? (
                            <BreadcrumbSeparator key={`separator-${index}`}>
                                <IconChevronRight width={16} height={16} />
                            </BreadcrumbSeparator>
                        ) : null}

                        <Link size="small" key={index} {...link.linkOptions}>
                            {link.label}
                        </Link>

                        <BreadcrumbSeparator key={`separator-${index}`}>
                            <IconChevronRight width={16} height={16} />
                        </BreadcrumbSeparator>
                    </Fragment>
                );
            })}

            {currentPage ? (
                <Text variant="small" fontWeight={600}>
                    {currentPage}
                </Text>
            ) : null}
        </BreadcrumbsContainer>
    );
};
